/* =================== DEPOIMENTOS =================== */
$(function () {
  const slideItems = $(".carrosel-depoimentos .depoimento-wrp").length;
  const slideDots = slideItems > 1;
  $(".carrosel-depoimentos").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    adaptiveHeight: true,
    autoplaySpeed: 3000,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});
